"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createStore() {
    const state = {
        rootElement: document.getElementById('ds-app'),
        webappRoot: document.getElementById('webapp'),
        activeItem: {
            content: {
                primaryImage: '',
                text: '',
                title: '',
                start: new Date(),
                end: new Date(),
            },
        },
        activitiesWereFetched: false,
        appData: {},
        appIds: {
            android: '',
            itunes: '',
        },
        appStoreBannersDisabled: false,
        backofficeSettings: {},
        baseUrl: '',
        brandInfo: {},
        brandSettings: {},
        bubbleFilters: [],
        currentLocale: '',
        dataFetchCompleted: false,
        deeplink: '',
        directory: [],
        enabledLocales: [],
        finalActivities: [],
        hideLogo: false,
        homeBottomCta: null,
        hotelView: '',
        imprintUrl: '',
        isHeaderHidden: false,
        isHeaderTransparent: false,
        itemContentScrollAmount: 0,
        itemDetailIsShown: false,
        kioskModeEnabled: false,
        logoRef: '',
        mode: '',
        navigations: [],
        newDataFetchNeeded: false,
        offers: [],
        pausedByInteraction: false,
        pollEndDate: '',
        pushNotificationsEnabled: false,
        queryParams: {},
        reloadNeeded: false,
        showCheckout: true,
        showProgressBar: false,
        showSearch: false,
        showToday: false,
        showTomorrow: false,
        showDayAfterTomorrow: false,
        slides: [],
        startItemDetailScrolled: false,
        stayId: null,
        theme: {},
        timezone: '',
        unfilteredActivities: [],
        urlSpecifiedLocale: '',
        userLandedOn: '',
        userData: {},
        userSelectedInterests: [],
        userSelectedLocale: '',
        venue: {},
        votingConfigId: 0,
        weather: {},
        // DS interactive
        isCarouselPaused: true,
    };
    return {
        setValue(key, value) {
            state[key] = value;
        },
        getValue(key) {
            return state[key];
        },
    };
}
exports.default = createStore;
